// override functions api.jquery.js

// 🔁 Gradientų generatorius
function getRandomGradient() {
  const colors = [
    ['#ff5f6d', '#ffc371'],
    ['#00c6ff', '#0072ff'],
    ['#f2709c', '#ff9472'],
    ['#ff9966', '#ff5e62'],
    ['#56ab2f', '#a8e063'],
    ['#614385', '#516395'],
    ['#02aab0', '#00cdac']
  ];
  const pair = colors[Math.floor(Math.random() * colors.length)];
  return `linear-gradient(90deg, ${pair[0]} 0%, ${pair[1]} 50%, ${pair[0]} 100%)`;
}

// 🌈 Įterpiame CSS animaciją + slide-up įėjimą
(function injectToastAnimationCSS() {
  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes slideGradient {
      0% { background-position-x: 0%; }
      100% { background-position-x: 200%; }
    }

    .animated-toast {
      background-size: 200% 100%;
      background-repeat: repeat-x;
      animation: slideGradient 8s linear infinite;
      color: #fff;
      padding: 16px 20px;
      font-size: 15px;
      box-shadow: 0 -4px 12px rgba(0,0,0,0.2);
      z-index: 9999;
      opacity: 0;
      transform: translateY(100%);
      transition: transform 0.4s ease, opacity 0.4s ease;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      flex-wrap: wrap;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }

    .animated-toast.show {
      opacity: 1;
      transform: translateY(0);
    }

    @media (max-width: 480px) {
      .animated-toast {
        font-size: 13px;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
      }
    }

    .toast-button {
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    .toast-button:hover {
      transform: scale(1.06);
      box-shadow: 0 0 10px rgba(255,255,255,0.6), 0 0 20px rgba(255,255,255,0.3);
    }
  `;
  document.head.appendChild(style);
})();

Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.cart-items');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  var str = (!!data.message) ? data.description : 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  jQuery('#modalAddToCartError .error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
};

Shopify.addItem = function(variant_id, quantity, callback) {
  quantity = quantity || 1;
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if (typeof callback === 'function') {
        callback(line_item);
      } else {
        Shopify.cartPopap(line_item);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  });
};

// ✅ Pranešimas su slide-up + gradientu + mygtukų efektu
Shopify.cartPopap = function(line_item) {
  const title = getCleanTitle(line_item.title || '');
  const gradient = getRandomGradient();

  jQuery('#custom-toast').remove();
  if (window.toastTimeout) clearTimeout(window.toastTimeout);

  const toast = `
    <div id="custom-toast" class="animated-toast" style="background: ${gradient};">
      <span style="margin-right: auto;">✅ „${title}“ pridėta į krepšelį</span>
      <div style="display: flex; gap: 10px; align-items: center; margin-left: 20px;">
        <a href="/cart" class="toast-button" style="background-color: #fff; color: #000; padding: 8px 16px; border-radius: 5px; font-weight: bold; text-decoration: none;">Peržiūrėti krepšelį</a>
<button onclick="jQuery('#custom-toast').slideUp(300)" class="toast-button" style="background-color: transparent; border: none; color: #fff; font-size: 20px; padding: 4px 12px; border-radius: 5px; cursor: pointer; line-height: 1;">✕</button>
      </div>
    </div>`;

  jQuery('body').append(toast);
  setTimeout(() => jQuery('#custom-toast').addClass('show'), 10);
  window.toastTimeout = setTimeout(() => {
    jQuery('#custom-toast').fadeOut(400, function() {
      jQuery(this).remove();
    });
    window.toastTimeout = null;
  }, 4000);
};

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = window.money_format;
  if (typeof cart_cell_id === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {
      cart_cell.empty();
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          if (value.length) {
            jQuery(".mini-cart").show();
            jQuery(".cart-empty-title").hide();
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if (i > 19) return false;
              const priceHTML = getDiscountedPriceHTML(item, formatMoney);
              jQuery(`<li class="single-shopping-cart">
                <div class="shopping-cart-img">
                  <a href="${item.url}"><img alt="" src="${item.image}"></a>
                </div>
                <div class="shopping-cart-title">
                  <h4><a href="${item.url}">${getCleanTitle(item.title)}</a></h4>
                  <h6>Kiekis: ${item.quantity}</h6>
                  ${priceHTML}
                </div>
                <div class="shopping-cart-delete">
                  <a href="javascript:void(0);" onclick="Shopify.removeItem(${item.variant_id})" title="Remove this item">
                    <i class="ion ion-close"></i>
                  </a>
                </div>
              </li>`).appendTo(table);
            });
          } else {
            jQuery(".mini-cart").hide();
            jQuery(".cart-empty-title").show();
          }
        }
      });
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);
  jQuery('.currency .active').trigger('click');
};

function changeHtmlValue(cell, value) {
  jQuery(cell).html(value);
}

function getCleanTitle(fullTitle) {
  if (!fullTitle || typeof fullTitle !== 'string') return 'Prekė';
  const closeParenIndex = fullTitle.indexOf(')');
  if (closeParenIndex !== -1) {
    return fullTitle.substring(0, closeParenIndex + 1).trim();
  }
  const dashSplit = fullTitle.split(/[–-]/);
  return dashSplit[0].trim();
}

function getDiscountedPriceHTML(item, formatMoney) {
  const title = (item.title || '').toUpperCase();
  const keywords = [
    'SIDABRAKRŪMIS', 'ROŽĖ', 'ŠILOKAS', 'BUDLĖJA', 'ILEKSAS', 'NANDINA',
    'VYTMENYS', 'MIETVEINĖ', 'LEVANDA', 'SORA', 'MISKANTAI', 'LENDRŪNAS',
    'VINGIRIS', 'STAMBIAŽIEDĖ', 'HORTENZIJA', 'BIJŪNAS', 'ŽIOGNAGĖ', 'ŠILINGĖ',
    'SIDABRAŽOLĖ', 'RŪTA', 'RODŽERSIJA', 'PAKALNUTĖ', 'NOTRA', 'MONARDA',
    'MELSVĖ', 'LIPIKAS', 'LIATRIS', 'KNIPOFIJA', 'KATŽOLĖ', 'KAMASIJA',
    'KALIMERIAI', 'JUODŽOLĖ', 'VILKDALGIAI', 'GUBOJA', 'GAURĖ', 'ERAIČINAI',
    'ČESNAKAS', 'BARŠKĖ', 'BAJORĖ', 'AUSKARĖLIAI', 'ASTILBĖS', 'ARUNKAS', 'ALŪNĖ'
  ];

  const isDiscounted = keywords.some(keyword => title.includes(keyword));
  const basePrice = item.price;
  const finalPrice = isDiscounted ? Math.round(basePrice * 0.7) : basePrice;

  if (isDiscounted) {
    return `<small><s>${Shopify.formatMoney(basePrice, formatMoney)}</s></small><br><span>${Shopify.formatMoney(finalPrice, formatMoney)}</span>`;
  }
  return `<span>${Shopify.formatMoney(finalPrice, formatMoney)}</span>`;
}
